const BASE_URL = process.env.VUE_APP_URL_DEV || 'http://localhost:8080'

function authHeaders(extra = {}) {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : ''
    return {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...extra,
    }
}

function buildQuery(params = {}) {
    const q = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === '') continue
        q.append(key, value)
    }
    const qs = q.toString()
    return qs ? '?' + qs : ''
}

async function jsonFetch(url, options = {}) {
    const response = await fetch(url, {
        ...options,
        headers: authHeaders(options.headers || {}),
    })
    const body = await response.json().catch(() => ({}))
    if (!response.ok) {
        const error = new Error(body?.message || body?.data?.detail || `Request failed: ${response.status}`)
        error.status = response.status
        error.payload = body
        throw error
    }
    return body?.data ?? body
}

export async function fetchSupportUnreadCount() {
    return jsonFetch(`${BASE_URL}/api/support/tickets/unread-count`)
}

export async function fetchSupportTickets(params = {}) {
    const data = await jsonFetch(`${BASE_URL}/api/support/tickets${buildQuery(params)}`)
    return {
        items: data?.items || [],
        meta: data?.meta || { current_page: 1, last_page: 1, per_page: 20, total: 0 },
    }
}

export async function fetchSupportTicket(id) {
    const data = await jsonFetch(`${BASE_URL}/api/support/tickets/${id}`)
    return data?.ticket || data
}

export async function createSupportTicket(payload) {
    const data = await jsonFetch(`${BASE_URL}/api/support/tickets`, {
        method: 'POST',
        body: JSON.stringify(payload),
    })
    return data?.ticket || data
}

export async function sendSupportTicketMessage(ticketId, body) {
    const data = await jsonFetch(`${BASE_URL}/api/support/tickets/${ticketId}/messages`, {
        method: 'POST',
        body: JSON.stringify({ body }),
    })
    return data
}

export async function markSupportTicketRead(ticketId) {
    return jsonFetch(`${BASE_URL}/api/support/tickets/${ticketId}/read`, { method: 'POST' })
}

export function formatTicketStatus(status) {
    const map = {
        open: 'Открыт',
        in_progress: 'В работе',
        resolved: 'Решён',
        closed: 'Закрыт',
    }
    return map[status] || status
}

export function formatTicketCategory(category) {
    const map = {
        billing: 'Оплата',
        technical: 'Техническая',
        other: 'Другое',
    }
    return map[category] || category
}

export function ticketStatusPillClass(status) {
    if (status === 'in_progress') return 'bento-pill--progress'
    if (status === 'resolved' || status === 'closed') return 'bento-pill--resolved'
    return 'bento-pill--open'
}
